import { Pagination, useListContext } from "react-admin";

const PostPagination = () => {
  const { total, data, isPending, isLoading, isFetching } = useListContext();
  if (isPending) return null;
  if (isFetching) return null;
  if (!total || total === 0) {
    return null;
  }
  return (
    <Pagination
      align="left"
      sx={{ textAlign: "left" }}
      rowsPerPageOptions={[25]}
    />
  );
};

export default PostPagination;
